import { Base } from "ui/Scripts/source/framework/base";
import { INumberTitle, NumberTitle } from "ui/Scripts/source/models/common/numberTitle";
import { CompanyMenuItem, ICompanyMenuItem } from "ui/Scripts/source/models/company/companyMenuItem";
import { IInstantMessageChannelItem, InstantMessageChannelItem } from "ui/Scripts/source/models/instantMessage/instantMessageChannelItem";
import { IInstantMessageListItems, InstantMessageListItems } from "ui/Scripts/source/models/instantMessage/instantMessageListItems";

export interface IInstantMessagePage {
    maxInstantMessageAttachmentSize: number;
    companies: ICompanyMenuItem[];
    authorizationLevels: INumberTitle[];
    channels: IInstantMessageChannelItem[];
    list: IInstantMessageListItems;
}

export class InstantMessagePage implements IInstantMessagePage {
    maxInstantMessageAttachmentSize: number;
    companies: CompanyMenuItem[];
    authorizationLevels: NumberTitle[];
    channels: InstantMessageChannelItem[];
    list: InstantMessageListItems;

    constructor();
    constructor(obj: IInstantMessagePage);
    constructor(obj?: any) {
        this.maxInstantMessageAttachmentSize = obj && obj.maxInstantMessageAttachmentSize || 0;
        this.companies = Base.getTypedArray(obj ? obj.companies : null, CompanyMenuItem);
        this.authorizationLevels = Base.getTypedArray(obj ? obj.authorizationLevels : null, NumberTitle);
        this.channels = Base.getTypedArray(obj ? obj.channels : null, InstantMessageChannelItem);
        this.list = new InstantMessageListItems(obj && obj.list || null);
    }
}